import React, { useContext, useEffect } from 'react'
import './Dialogsolved.css'
import Que from "../../imgs/que.png";
import Resume from "../../imgs/resume.png";
import Help from "../../imgs/help.png";
import Globalcontext from '../../Context/Globalcontext';


const Dialogsolved = ({ message, onDialog, submessage, functionname, button1text, button2text }) => {
    const a = useContext(Globalcontext);
    const handledialog = () => {
        onDialog(true);
    }

    const handlecancel = () => {
        onDialog(false);
    }

    const handlepointq = (que) => {
        a.setIndex(que);
        onDialog(false);
    }


    return (
        <div
            style={{
                position: "fixed",
                top: "0",
                left: "0",
                right: "0",
                bottom: "0",
                backgroundColor: "rgba(0,0,0,0.5)"
            }}

        >
            <div
                onClick={(e) => e.stopPropagation()}
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%,-50%)",
                    background: "white",
                    padding: "20px",
                    borderRadius: "10px",
                    backgroundColor: "whitesmoke"
                }}
            >
                <div className="dialogmain">
                    <div className="icondialog">
                        <img src={Que} alt="" />
                    </div>
                    <span style={{ color: "#111", fontSize: "13px", fontWeight: "bold", width: "100%", display: "flex", justifyContent: "center", alignItems: "center", marginTop: "5px" }}>{message}</span>
                    <span style={{ marginTop: "4px", color: "black", fontSize: "16px" }}>{submessage}</span>

                    <div className="scoredetails2">
                        <div className="scorerow2">
                            <div className={a.calccolor(1)}>
                                <span onClick={() => handlepointq(0)}>1</span>
                            </div>
                            <div className={a.calccolor(2)}>
                                <span onClick={() => handlepointq(1)}>2</span>
                            </div>
                            <div className={a.calccolor(3)}>
                                <span onClick={() => handlepointq(2)}>3</span>
                            </div>
                            <div className={a.calccolor(4)}>
                                <span onClick={() => handlepointq(3)}>4</span>
                            </div>
                            <div className={a.calccolor(5)}>
                                <span onClick={() => handlepointq(4)}>5</span>
                            </div>
                            <div className={a.calccolor(6)}>
                                <span onClick={() => handlepointq(5)}>6</span>
                            </div>
                            <div className={a.calccolor(7)}>
                                <span onClick={() => handlepointq(6)}>7</span>
                            </div>
                            <div className={a.calccolor(8)}>
                                <span onClick={() => handlepointq(7)}>8</span>
                            </div>
                            <div className={a.calccolor(9)}>
                                <span onClick={() => handlepointq(8)}>9</span>
                            </div>
                            <div className={a.calccolor(10)}>
                                <span onClick={() => handlepointq(9)}>10</span>
                            </div>
                        </div>
                        <div className='line' />
                        <div onClick={() => onDialog(false)} className="scorerow2">
                            <div className={a.calccolor(11)}>
                                <span onClick={() => handlepointq(10)}>11</span>
                            </div>
                            <div className={a.calccolor(12)}>
                                <span onClick={() => handlepointq(11)}>12</span>
                            </div>
                            <div className={a.calccolor(13)}>
                                <span onClick={() => handlepointq(12)}>13</span>
                            </div>
                            <div className={a.calccolor(14)}>
                                <span onClick={() => handlepointq(13)}>14</span>
                            </div>
                            <div className={a.calccolor(15)}>
                                <span onClick={() => handlepointq(14)}>15</span>
                            </div>
                            <div className={a.calccolor(16)}>
                                <span onClick={() => handlepointq(15)}>16</span>
                            </div>
                            <div className={a.calccolor(17)}>
                                <span onClick={() => handlepointq(16)}>17</span>
                            </div>
                            <div className={a.calccolor(18)}>
                                <span onClick={() => handlepointq(17)}>18</span>
                            </div>
                            <div className={a.calccolor(19)}>
                                <span onClick={() => handlepointq(18)}>19</span>
                            </div>
                            <div className={a.calccolor(20)}>
                                <span onClick={() => handlepointq(19)}>20</span>
                            </div>
                        </div>
                        <div className='line' />

                        <div className="buttonclass">
                            <button
                                onClick={handledialog}
                                className="buttonend"
                            >
                                {button1text}
                            </button>
                            <button
                                onClick={handlecancel}
                                style={{
                                    color: "#111",
                                    cursor: "pointer",
                                    marginTop: "1px",
                                    background: "none"
                                }}
                            >
                                {button2text}
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default Dialogsolved
